interface TestIdObject {
  'data-testid'?: string;
}

export const testId = (id: string): TestIdObject => (id ? { 'data-testid': id } : {});
